export default __webpack_public_path__ + "static/pride-e24f0917060512eee24f628f3408965a.jpg";